import React from 'react'
import Box from '@mui/material/Box'
import {reExportedColors} from '../../1elements'

const TableHeaderRow = ({children}) => {
    return(
        <Box
            sx={{
                background: reExportedColors.DARK_GREY,
                borderRadius: '4px',
                color: 'white',
                display: 'grid',
                gridColumnStart: 'span 12',
                gridTemplateColumns: 'repeat(12, 1fr)',
                position: 'sticky',
                top: 0,
                zIndex: 1
            }}
        >
            {children}
        </Box>
    )
}

export default TableHeaderRow
